module.exports = __webpack_public_path__ + "img/icons-right-arrow.00faf988.svg";